import React, { useEffect } from 'react'
import { Col, Row } from 'antd'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/Button'

import { JobRoleWholeFlex, SectionName } from '../JobRoles/PageHeader/style'
import { LeftSection } from '../Placement/style'
import { TopHeadingTPO } from '../TPORequests/style'

import {
    CardItem,
    CardHeader,
    CardBody,
    RoundImage,
    Heading,
    SubHeading,
    ListItem,
    ButtonStyle,
    CardTop,
    CardStats,
    StatRow,
} from './style'

import profileIcon from './Components/images/ProfileIcon.png'
import optoutIcon from './Components/images/OptOutIcon.png'
import jobIcon from './Components/images/JobIcon.png'
import restrictionIcon from './Components/images/RestrictionIcon.png'
import { useDispatch, useSelector } from 'react-redux'
import { studentsMetricsData } from '../Students/actions'
import { getTPOMetrics } from '../TPORequests/actions'

function Approvals() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const studentMetrics = useSelector(state => state?.institute?.studentsMetrics || {})
    const tpoMetrics = useSelector(state => state?.tpoRequest?.tpoMetrics || {})
    useEffect(() => {
        dispatch(studentsMetricsData())
        dispatch(getTPOMetrics())
    }, [dispatch])

    const approvalsData = [
        {
            key: 'profile',
            title: 'Profile Setting',
            subtitle: 'Approvals',
            description:
                'Review and act on student profile update requests. These include changes to personal, academic, or placement-related details that require TPO approval before being applied.',
            icon: profileIcon,
            route: '/tpoApproval',
            stats: [{ label: 'Approval Pending', value: studentMetrics?.approval_pending_count || 0 }],
        },
        {
            key: 'optout',
            title: 'Opting Out',
            subtitle: 'Approvals',
            description:
                'Manage student requests to opt out of placements or re-enter the placement process. Track pending approvals, re-opt-ins, and currently opted-out students.',
            icon: optoutIcon,
            smallIcon: true,
            route: '/students?optedStatus=opt-out',
            stats: [
                { label: 'Pending TPO approval', value: studentMetrics?.optOut_pending || 0 },
                { label: 'Re-opting In', value: studentMetrics?.optIn_pending || 0 },
                { label: 'Opt-ed out Candidates', value: studentMetrics?.optOut_count || 0 },
            ],
        },
        {
            key: 'job',
            title: 'Job Specific',
            subtitle: 'Approvals',
            description:
                'View and process approval requests related to specific job roles. This may include eligibility exceptions, special permissions, or role-based approvals raised by students or administrators.',
            icon: jobIcon,
            route: '/tpoRequests',
            stats: [
                { label: 'Total Requests Pending', value: tpoMetrics?.pending_count || 0 },
                { label: 'Urgent Requests', value: tpoMetrics?.urgent_count || 0 },
            ],
        },
        {
            key: 'restriction',
            title: 'Other Restriction',
            subtitle: 'Approvals',
            description:
                'Approve or update restrictions applied to students. This includes adding or removing students from restricted or unrestricted categories as per institute policy.',
            icon: restrictionIcon,
            route: '/students?isRestricted=true',
            stats: [
                { label: 'Restricted Candidates', value: studentMetrics?.restricted_count || 0 },
            ],
        },
    ]

    return (
        <div>
            <JobRoleWholeFlex>
                <LeftSection>
                    <SectionName>
                        <TopHeadingTPO>Approvals</TopHeadingTPO>
                    </SectionName>
                </LeftSection>

                <Row gutter={[24, 24]} style={{ marginTop: '40px' }}>
                    {approvalsData.map(item => (
                        <Col
                            key={item.key}
                            xs={{ flex: '100%' }}
                            sm={{ flex: '50%' }}
                            md={{ flex: '40%' }}
                            lg={{ flex: '20%' }}
                            xl={{ flex: '10%' }}
                        >
                            <CardItem>
                                <CardTop>
                                    <CardHeader>
                                        <RoundImage>
                                            <img
                                                src={item.icon}
                                                alt={item.title}
                                                style={{
                                                    maxWidth: item.smallIcon ? '99%' : '100%',
                                                    maxHeight: item.smallIcon ? '99%' : '100%',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </RoundImage>

                                        <div>
                                            <Heading>{item.title}</Heading>
                                            <SubHeading>{item.subtitle}</SubHeading>
                                        </div>
                                    </CardHeader>

                                    <CardBody>
                                        <ListItem>{item.description}</ListItem>
                                    </CardBody>
                                </CardTop>
                                {item.stats && (
                                    <CardStats>
                                        {item.stats.map(stat => (
                                            <StatRow key={stat.label}>
                                                <span>{stat.label}</span>
                                                <b>{stat.value}</b>
                                            </StatRow>
                                        ))}
                                    </CardStats>
                                )}

                                <ButtonStyle>
                                    <Button.Primary
                                        text="Enter"
                                        onClick={() => navigate(item.route)}
                                    />
                                </ButtonStyle>
                            </CardItem>
                        </Col>
                    ))}
                </Row>
            </JobRoleWholeFlex>
        </div>
    )
}

export default Approvals